import React from 'react';
import "./about.css"
import { MoreHoriz } from '@mui/icons-material';
import TeamPerson from './TeamPerson';
const About = () => {
    return (
        <div id="about" className="about-area">
            <div className="team-area-02 blue-dark-bg pt-125 " style={{ backgroundImage: "https://www.devsnews.com/template/micoach/micoach/assets/img/bg/team-bg-01.jpg" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 offset-lg-3 offset-xl-3">
                            <div className="section-title section-title-white text-center mb-65">
                                <span><MoreHoriz /> Team Members <MoreHoriz /></span>
                                <h2>Team - Advance IT Institute </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <TeamPerson />
                        <TeamPerson />
                        <TeamPerson />
                        <TeamPerson />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;